import { render, staticRenderFns } from "./YzDivider.vue?vue&type=template&id=26d20ef7&scoped=true&lang=pug&"
import script from "./YzDivider.vue?vue&type=script&lang=js&"
export * from "./YzDivider.vue?vue&type=script&lang=js&"
import style0 from "./YzDivider.vue?vue&type=style&index=0&id=26d20ef7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d20ef7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
